import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TdLoadingService, TdDigitsPipe, TdDialogService, ITdDataTableColumn, TdMediaService, TdDataTableService } from '@covalent/core';
import { MdDialog, MdSnackBar, MdSelect } from '@angular/material';

import { LoginService } from '../../../services';

@Component({
    selector: 'qs-perfil',
    templateUrl: './perfil.component.html',
    styleUrls: ['./perfil.component.scss'],
})

export class PerfilComponent implements AfterViewInit {

    public usuario: string;
    public pass: string;
    public passConfirmar: string;
    title: string;
    public profesional: any;
    public nombreUsuario: string;

    filtroPendientes: boolean = false;
    filtroAgenda: string;

    constructor(private _titleService: Title,
        private _loadingService: TdLoadingService,
        private _dialogService: TdDialogService,
        private _loginService: LoginService,
        public media: TdMediaService,
        public dialog: MdDialog,
        public snackBar: MdSnackBar,
        private _router: Router,
        private _changeDetectorRef: ChangeDetectorRef) { }

    ngAfterViewInit(): void {
        this.media.broadcast();
        this._titleService.setTitle('perfil');
        this.title = this._titleService.getTitle();
        this._loadingService.register('perfil.load');
        this.profesional = this._loginService.profesional;

        this.usuario = this.profesional.Login;
        this.nombreUsuario = this.profesional.Personal.Nombre + ' '
                                + this.profesional.Personal.Apellido1 + ' '
                                + this.profesional.Personal.Apellido2;

        this._loadingService.resolve('perfil.load');
        this._changeDetectorRef.detectChanges();
    }

    update(): void {
        this._loadingService.register();

        if (this.pass !== this.passConfirmar) {
            this._loginService.mostrarMensaje('Las contraseña y su confirmación deben coincidir', 'OK', 2000);
            this._loadingService.resolve();
        } else {
            this._loginService.profesional.CambiaPassword = true;
            this._loginService.profesional.PassNuevoEncriptado = this.pass.trim();
            this._loginService.updatePassword(this._loginService.profesional).subscribe((res: any) => {
                if (res.error !== undefined) {
                    this._loginService.mostrarMensaje(res.error, 'OK', 2000);
                    this._loadingService.resolve();
                } else {
                    this._loginService.mostrarMensaje('Contraseña cambiada correctamente', 'OK', 2000);
                    this._loadingService.resolve();
                }
            }, (error: any): any => {
                this._loadingService.resolve();
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/main/perfil/perfil.component.ts